<script lang="ts">
  import CheckmarkIcon from "./CheckmarkIcon.svelte";
  import LoaderIcon from "./LoaderIcon.svelte";
  import type { Toast } from "../core/types";
  import SuccessIcon from "./SuccessIcon.svelte";
  import ErrorIcon from "./ErrorIcon.svelte";
  import CancelIcon from "./CancelIcon.svelte";
  import WarningIcon from "./WarningIcon.svelte";
  interface Props {
    toast: Toast;
  }

  let { toast }: Props = $props();
  let { type, icon, iconTheme } = $derived(toast);
</script>

{#if typeof icon === "string"}
  <div class="animated">{icon}</div>
{:else if typeof icon !== "undefined"}
  {@const IconComponent = icon}
  <IconComponent />
{:else if type !== "blank"}
  <div class="indicator icon-{type}">
    <LoaderIcon {...iconTheme} />
    {#if type !== "loading"}
      <div class="toaster-status">
        {#if type === "error"}
          <ErrorIcon />
        {:else if type === "success"}
          <SuccessIcon />
        {:else if type === "warning"}
          <WarningIcon />
        {:else if type === "cancel"}
          <CancelIcon />
        {:else}
          <CheckmarkIcon {...iconTheme} />
        {/if}
      </div>
    {/if}
  </div>
{/if}

<style>
  .indicator {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 20px;
    min-height: 20px;
  }
  .icon-success,
  .icon-error,
  .icon-cancel,
  .icon-warning {
    min-width: 30px;
    min-height: 30px;
  }

  .toaster-status {
    position: absolute;
  }

  .animated {
    position: relative;
    transform: scale(0.6);
    opacity: 0.4;
    min-width: 20px;
    animation: enter 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  }

  @keyframes enter {
    from {
      transform: scale(0.6);
      opacity: 0.4;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
</style>
